import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TreeMapModule } from '@swimlane/ngx-charts';
import { TreeviewConfig, TreeviewItem } from 'ngx-treeview';

@Component({
  selector: 'app-treeview-dropdown',
  templateUrl: './treeview-dropdown.component.html',
  styleUrls: ['./treeview-dropdown.component.scss'],
})
export class TreeviewDropdownComponent implements OnInit {
  @Input() items: TreeviewItem[];
  @Input() isCheckBoxRequired;
  @Input() isReadonly = false;
  @Output() valueChange = new EventEmitter();
  @Input() type = '';
  @Input() disabled;
  values: number[];
  scrollData;

  buttonClasses = [
    'btn-outline-primary',
    'btn-outline-secondary',
    'btn-outline-success',
    'btn-outline-danger',
    'btn-outline-warning',
    'btn-outline-info',
    'btn-outline-light',
    'btn-outline-dark',
  ];
  buttonClass = this.buttonClasses[0];
  config: TreeviewConfig;

  constructor() {}

  ngOnInit(): void {
    this.config = TreeviewConfig.create({
      hasAllCheckBox: this.isCheckBoxRequired ? true : false,
      hasFilter: true,
      hasCollapseExpand: true,
      decoupleChildFromParent: false,
      maxHeight: 400
    });
  }
  setValues = (values) => {
    const outputObject = {
      value: values,
      type: this.type
    };
    this.valueChange.emit(outputObject);
  };

  onFilterChange(value: string): void {
    console.log('filter:', value);
  }
}
